export default "__VITE_ASSET__aJJX4JQ___"